var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('Govem_bar'),_c('base-material-card',{staticClass:"px-5 py-3",attrs:{"icon":"mdi-calculator","title":"ผลการเลื่อนค่าตอบแทนพนักงานราชการ (สถาบัน)"}},[_c('CompensationResultView')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }